import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { APIs } from '../config/api.constant';
import { map } from 'rxjs/operators';
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: 'root'
  })
export class EmployeeService {
    constructor(private apiSrv: ApiService) {}

    getMyCompanyDetails(parkTenantId:string) : Observable<any> {
        return this.apiSrv.get(`${APIs.getMyCompanyDetails}?parkTenantId=${parkTenantId}&pageNo=1&size=5`).pipe(map(response=> {
            return response;
        }))
    }

    revokeEmployeeRights(payload) {
        return this.apiSrv.post(APIs.revokeEmployeeRights, payload).pipe(map(response=> {
            return response;
        }))
    }

    saveEmployees(payload) {
      return this.apiSrv.post(APIs.saveEmployees, payload).pipe(map(response=> {
        return response;
      }))
    }

    markAsAdmin(payload) {
      return this.apiSrv.post(APIs.markAsAdmin, payload).pipe(map(response=> {
        return response;
      }))
    }

    revokeAsAdmin(payload) {
      return this.apiSrv.post(APIs.revokeAsAdmin, payload).pipe(map(response=> {
        return response;
      }))
    }

    getBuildingByParkId(parkId) {
      return this.apiSrv.get(`${APIs.getBuildingByParkId}?parkId=${parkId}`).pipe(map(response=> {
          return response;
      }))
    }

    getBuildingByParkIdAndTenatID(parkId,tenantId) {
      return this.apiSrv.get(`${APIs.getBuildingByParkIdAndTenatID}?parkId=${parkId}&parkTenantId=${tenantId}`).pipe(map(response=> {
          return response;
      }))
    }

    getEmployeeListByFilter(payload) {
      return this.apiSrv.post(APIs.employeeListByFilter, payload).pipe(map(response=> {
        return response;
      }))
    }

    giveEmployeeVMSInvitationRights(payload) {
      return this.apiSrv.post(APIs.employeeVmsInvitationRights, payload).pipe(map(response=> {
        return response;
      }))
    }

    saveEmployeeStatus(payload) {
      return this.apiSrv.post(APIs.saveEmployeeStatus, payload).pipe(map(response=> {
        return response;
      }))
    }

    approveVmsRights(payload) {
      return this.apiSrv.post(APIs.approveVmsAccess, payload).pipe(map(response=> {
        return response;
      }))
    }

    getEmployeeListBasedonTenant(payload) {
      return this.apiSrv.post(APIs.EmployeeListBasedonTenant, payload).pipe(map(response=> {
        return response;
      }))
    }
}
